import styled from 'styled-components'

import { breakpoints } from '@src/constants/breakpoints'

export const LocationOverlayContainer = styled.div<{ noPadding?: boolean }>`
  @media (min-width: ${breakpoints.largeTablet}px) {
    padding: ${props => (props.noPadding ? '0px' : '16px')};
  }
`
